document.addEventListener('DOMContentLoaded', async function() {
  // ──────── 0) INYECTAR CSS PARA CARD + PRECIOS + SIN SUBRAYADO ────────
  if (!document.getElementById('rvp-styles')) {
    const style = document.createElement('style');
    style.id = 'rvp-styles';
    style.textContent = `
      /* Quitar subrayado de los enlaces dentro de la tarjeta */
      recently-viewed-products .product-card__link {
        text-decoration: none !important;
      }

      /* Contenedor flex */
      recently-viewed-products .recently-viewed-products-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;
        padding: 1rem 0;
      }

      /* Cada tarjeta de ancho fijo igual al ancho de la imagen */
      recently-viewed-products .product-card {
        flex: 0 1 301.66px;
        background: none;
        border: none;
        box-shadow: none;
      }

      /* Imagen cuadrada 301.66×301.66px */
      recently-viewed-products .product-card__image-wrapper {
        width: 301.66px;
        height: 301.66px;
        position: relative;
        overflow: hidden;
      }
      recently-viewed-products .product-card__image {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      /* Título (Avenir Next, 19.2px, color #15003F) */
      recently-viewed-products .rvp-title,
      recently-viewed-products .product-card__title {
        font-family: "Avenir Next", sans-serif;
        font-size: 19.2px;
        color: #15003F;
        text-align: center;
        margin: 0.5rem 0;
        line-height: 1.2;
      }

      /* Precio tachado (Avenir Next, 16.8px, color #000) */
      recently-viewed-products .product-card__compare-price {
        display: block;
        font-family: "Avenir Next", sans-serif;
        font-size: 16.8px;
        color: #000000;
        text-decoration: line-through;
        text-align: center;
        margin-bottom: 0.25rem;
      }

      /* Precio de venta (Avenir Next, 19.2px, color #000) */
      recently-viewed-products .product-card__sale-price {
        font-family: "Avenir Next", sans-serif;
        font-size: 19.2px;
        color: #000000;
        font-weight: bold;
        text-align: center;
      }

      /* “Más IVA” */
      recently-viewed-products .product-card__tax {
        display: block;
        font-family: "Avenir Next", sans-serif;
        font-size: 16.8px;
        color: #000000;
        text-align: center;
        margin-top: 0.25rem;
      }
    `;
    document.head.appendChild(style);
  }

  // ──────── 1) TRACK ────────
  const path = window.location.pathname;
  if (path.startsWith('/products/')) {
    const handle = path.split('/products/')[1].replace(/\/$/, '');
    let viewed = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];
    viewed = viewed.filter(h => h !== handle);
    viewed.unshift(handle);
    if (viewed.length > 10) viewed = viewed.slice(0, 10);
    localStorage.setItem('recently-viewed-products', JSON.stringify(viewed));
  }

  // ──────── 2) RENDER ────────
  const comp    = document.querySelector('recently-viewed-products');
  if (!comp) return;
  const wrapper = comp.querySelector('.recently-viewed-products-content');
  const handles = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];
  if (!handles.length) {
    comp.classList.add('hide');
    return;
  }

  // Insertar título centrado si no existe
  if (!comp.querySelector('.rvp-title')) {
    const title = document.createElement('h2');
    title.className   = 'rvp-title';
    title.textContent = 'Productos vistos recientemente';
    wrapper.parentNode.insertBefore(title, wrapper);
  }

  const maxCards = parseInt(comp.dataset.count, 10) || 4;
  for (let i = 0; i < Math.min(handles.length, maxCards); i++) {
    try {
      const res = await fetch(`/products/${handles[i]}.js`);
      if (!res.ok) continue;
      const product = await res.json();
      const hasDiscount  = product.compare_at_price > product.price;
      const salePrice    = (product.price / 100).toFixed(2);
      const comparePrice = hasDiscount
        ? (product.compare_at_price / 100).toFixed(2)
        : null;

      const card = document.createElement('div');
      card.className = 'product-card';
      card.innerHTML = `
        <a href="${product.url}" class="product-card__link">
          <div class="product-card__image-wrapper">
            <img
              src="${product.images[0] || ''}"
              alt="${product.title}"
              class="product-card__image"
            />
          </div>
          <div class="product-card__title">${product.title}</div>
          <div class="product-card__compare-price">
            ${hasDiscount ? `$${comparePrice} MXN Más IVA` : ''}
          </div>
          <div class="product-card__sale-price">
            $${salePrice} MXN
          </div>
          <div class="product-card__tax">Más IVA</div>
        </a>
      `;
      wrapper.appendChild(card);
    } catch (err) {
      console.warn('Error cargando producto:', handles[i], err);
    }
  }

  comp.classList.remove('hide');
});
